module.exports = __webpack_public_path__ + "static/media/comingSoon.faf2924d.png";